

// Currency js custom code

$(document).ready(function () {
  // Open currency selector drawer when the button is clicked
  $('.lc__btn').click(function () {
    $('.explore__drawer-main .drawer--close').trigger('click');
    setTimeout(function () {
    $('body').addClass('js-drawer-open-right');
    $('.local-currency__section').addClass('active');
    setTimeout(function () {
      $('.local-currency__section').addClass('open');
    }, 10);
    }, 10);
  });

  // Close the currency selector drawer
  $('.localization-form__main .drawer--close').click(function () {
    setTimeout(function () {
      $('.local-currency__section').removeClass('active');
    }, 200);
    $('body').removeClass('js-drawer-open-right');
    $('.local-currency__section').removeClass('open');
  });

  // Handle click on currency item
  $('.local-currency__section .disclosure__item_el').click(function (e) {
    var list = $(this).closest('.disclosure__item');
    if ($(list).hasClass('selected')) {
      $(list).removeClass('selected');
      $(this).closest('.disclosure').find('.currency__btn').attr('disabled', 'disabled');
    } else {
      var attr = list.attr('selected');
      console.log(attr);
      if (typeof attr !== 'undefined' && attr !== false) {
        $(list).addClass('selected');
        $(list).siblings().removeClass('selected');
         $(this).closest('.disclosure').find('.currency__btn').attr('disabled', 'disabled');
      }else{
        $(list).addClass('selected');
        $(list).siblings().removeClass('selected');
        $(this).closest('.disclosure').find('.currency__btn').removeAttr('disabled');
      }
    }
    $(this).closest('.disclosure').find('input[name="country_code"]').val($(this).attr('data-value'));
    // $(this).closest('.disclosure').find('.currency__btn').trigger('click');
  });

  // Search functionality for countries
  $('#countrySearch').on('keyup change', function () {
    var searchValue = $(this).val().toLowerCase();
    $('.local-currency__section .disclosure__list .disclosure__item').each(function () {
      var country = $(this).data('country').toLowerCase();
      if (country.includes(searchValue)) {
        $(this).removeClass('hidden');
      } else {
        $(this).addClass('hidden');
      }
    });
  });

  $('.ld__btn').click(function (params) {
    $('.explore__drawer-main .drawer--close').trigger('click');
    $('#languageDrawer').addClass('open');
    $('body').addClass('js-drawer-open-right');
  })
  $('.language-drawer__close').click(function (params) {
    $('#languageDrawer').removeClass('open');
    $('body').removeClass('js-drawer-open-right');
  })
});


// Language js custom code
class LocalizationForm {
  constructor() {
    this.elements = {
      toggleButton: document.querySelector('.language-drawer-toggle'),
      drawer: document.getElementById('languageDrawer'),
      closeButton: document.querySelector('.language-drawer__close'),
      links: document.querySelectorAll('.localization__link'),
      form: document.getElementById('localizationForm'),
      input: document.getElementById('localeInput'),
      overlay: document.getElementById('languageOverlay'), // New overlay element
      applyButton: document.getElementById('applyLanguageButton'), // Apply button
    };

    this.selectedLanguage = null; // Store the selected language

    // Initialize event listeners
    this.initListeners();
  }

  // Initialize event listeners
  initListeners() {
    if (this.elements.toggleButton) {
      // this.elements.toggleButton.addEventListener('click', this.openDrawer.bind(this));
        // this.elements.toggleButton.addEventListener('click', function (params) {
        //   this.openDrawer();
        // });
    }
    // if (this.elements.closeButton) {
    //   this.elements.closeButton.addEventListener('click', this.closeDrawer.bind(this));
    // }
    if (this.elements.links) {
      this.elements.links.forEach(link =>
        link.addEventListener('click', this.handleLanguageSelect.bind(this))
      );
    }

    // Add event listener for the Apply button
    if (this.elements.applyButton) {
      this.elements.applyButton.addEventListener('click', this.applyLanguage.bind(this));
    }

    document.addEventListener('click', this.handleOutsideClick.bind(this));
  }

  // Open the language drawer
  openDrawer() {
    // this.elements.drawer.classList.add('open');
    // this.elements.overlay.classList.add('open'); // Show overlay
    // document.body.classList.add('js-drawer-open-right');
  }

  // Close the language drawer
  closeDrawer() {
    // this.elements.drawer.classList.remove('open');
    // this.elements.overlay.classList.remove('open'); // Hide overlay
    // document.body.classList.remove('js-drawer-open-right');
  }

  // Handle clicks outside the drawer to close it
  handleOutsideClick(event) {
    if (
      this.elements.drawer &&
      !this.elements.drawer.contains(event.target) &&
      !this.elements.toggleButton.contains(event.target) &&
      !this.elements.overlay.contains(event.target) // Add this check for the overlay
    ) {
      this.closeDrawer();
    }
  }

  // Handle language selection
  handleLanguageSelect(event) {
    event.preventDefault();
    const selectedLanguage = event.target.dataset.value;

    this.selectedLanguage = selectedLanguage; // Store the selected language

    // Add 'is-active' class to the selected language link and remove from others
    let hasSelectedLink = false;

    this.elements.links.forEach(link => {
      if (link.dataset.value === selectedLanguage) {
        link.classList.add('is-active');
        if (link.hasAttribute('selected')) {
          hasSelectedLink = true;
        }
      } else {
        link.classList.remove('is-active');
      }
    
      
    });
    
    if (this.elements.applyButton) {
      if (hasSelectedLink) {
        this.elements.applyButton.classList.remove('is-selected');
      } else {
        this.elements.applyButton.classList.add('is-selected');
      }
    }
  }

  // Handle apply button click
  applyLanguage() {
    if (this.selectedLanguage && this.elements.input) {
      // Update the hidden input value with the selected language
      this.elements.input.value = this.selectedLanguage;

      // Submit the localization form
      if (this.elements.form) {
        this.elements.form.submit();
      } else {
        console.error('Localization form not found!');
      }
    } else {
      console.error('No language selected!');
    }

     if (this.elements.applyButton) {
      this.elements.applyButton.classList.remove('is-selected');
    }
  }
}

// Initialize the LocalizationForm after the DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
  new LocalizationForm();
});

document.getElementById("DrawerOverlay").addEventListener("click", function() {
    // var languageDrawer = document.querySelector(".language-drawer");
    // languageDrawer.classList.remove("open");
    var currencyDrawer = document.querySelector(".local-currency__section");
    currencyDrawer.classList.remove("open");
  setTimeout(function () {
    currencyDrawer.classList.remove("active");
  }, 200);
});


  // $(".selected-display").on("click", function() {
  //       const $optionsContainer = $(this).closest('.custom-select').find(".options-container");
  //       $optionsContainer.toggleClass("active");
  //       $(this).closest('.custom-select').find('.arrow').toggleClass('rotate');
  //   });


 $('.option-item').click(function () {
      var first_var_title = $(this).attr('data-country');
      $(this).closest('.custom-select-1').find('.selected-display').text(first_var_title);

      var first_var_price = $(this).attr('data-languge');
      $(this).closest('.custom-select-2').find('.selected-display').text(first_var_price);
    });




          document.addEventListener('DOMContentLoaded', function() {
  const countryItems = document.querySelectorAll('.disclosure__item_el');
  const countryAttrElement = document.querySelector('.country-attr-here');
  
  // Load the selected country from localStorage (if any)
  const savedCountry = localStorage.getItem('selectedCountry');
  if (savedCountry) {
    countryAttrElement.classList.add(savedCountry); // Add the saved country class to the element
    // Optionally highlight the country item that was previously selected
    const selectedItem = document.querySelector(`[data-value="${savedCountry}"]`);
    if (selectedItem) {
      selectedItem.classList.add('selected');
    }
  }

  // Handle Country Selection
  countryItems.forEach(item => {
    item.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Remove the selected class from all items
      countryItems.forEach(i => i.classList.remove('selected'));
      
      // Add the selected class to the clicked country
      item.classList.add('selected');
      
      // Get the data-value of the clicked country
      const countryCode = item.dataset.value;

      // Remove the previously added class from country-attr-here
      countryAttrElement.classList.forEach(className => {
        if (className !== 'country-attr-here') {
          countryAttrElement.classList.remove(className);
        }
      });

      // Add the clicked country's data-value as a class to the 'country-attr-here' element
      countryAttrElement.classList.add(countryCode);

      // Save the selected country in localStorage
      localStorage.setItem('selectedCountry', countryCode);
    });
  });
});



 document.querySelectorAll('.localization__list li').forEach(function(item) {
      item.addEventListener('click', function() {
          // Remove 'selected' class from all li elements
        $(this).closest('.custom-select').find('.selected-display').removeClass('selected_grey');
          document.querySelectorAll('.localization__list li').forEach(function(li) {
              li.classList.remove('selected');
          });

          // Add 'selected' class to the clicked li element
          this.classList.add('selected');

          // Get the value of the clicked li element
          var selectedValue = this.getAttribute('value');

          // Update the select option to match the clicked li element's value
          var select = document.getElementById('ContactFormCategory');
          select.value = selectedValue;
      });
  });


